import ApiProvider from '../../core/api/ApiProvider';

class StartupTokenApiClient
{
    public async initializeStartupToken(customerId: string): Promise<void> {
        return await ApiProvider.get<any>(`api/Startup/${customerId}`);
    }
}

export default new StartupTokenApiClient();